"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserVariableDefinition = exports.isTabVariableDefinition = exports.isPeriodVariableDefinition = exports.WidgetConfigMap = exports.markdownImgRegExpPattern = exports.WidgetType = void 0;
const schemas_1 = require("./schemas");
var WidgetType;
(function (WidgetType) {
    WidgetType["BIG_NUMBER"] = "big_number";
    WidgetType["TABLE"] = "table";
    WidgetType["BAR"] = "bar";
    WidgetType["MARKDOWN"] = "markdown";
    WidgetType["CHART"] = "bar_chart";
    WidgetType["ACTION"] = "action";
    WidgetType["GAUGE"] = "gauge";
    WidgetType["SEPARATOR"] = "separator";
    WidgetType["DYNAMIC_TABLE"] = "dynamic_table";
})(WidgetType = exports.WidgetType || (exports.WidgetType = {}));
exports.markdownImgRegExpPattern = /<img alt="([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})"( src="null")?( style="[^"]*")?( draggable="[^"]*")?( \/)?>/g;
exports.WidgetConfigMap = {
    [WidgetType.BIG_NUMBER]: { schema: schemas_1.bigNumberSchemaValidator },
    [WidgetType.TABLE]: { schema: schemas_1.tableSchemaValidator },
    [WidgetType.BAR]: { schema: schemas_1.barSchemaValidator },
    [WidgetType.MARKDOWN]: { schema: schemas_1.markdownSchemaValidator },
    [WidgetType.CHART]: { schema: schemas_1.chartSchemaValidator },
    [WidgetType.ACTION]: { schema: schemas_1.actionSchemaValidator },
    [WidgetType.GAUGE]: { schema: schemas_1.gaugeSchemaValidator },
    [WidgetType.SEPARATOR]: { schema: schemas_1.separatorSchemaValidator },
    [WidgetType.DYNAMIC_TABLE]: { schema: schemas_1.dynamicTableSchemaValidator },
};
const isPeriodVariableDefinition = (variable) => variable.type === 'period';
exports.isPeriodVariableDefinition = isPeriodVariableDefinition;
const isTabVariableDefinition = (variable) => variable.type === 'tab';
exports.isTabVariableDefinition = isTabVariableDefinition;
const isUserVariableDefinition = (variable) => variable.type === 'user';
exports.isUserVariableDefinition = isUserVariableDefinition;
